import { ThemeProvider as MuiThemeProvider, StylesProvider } from "@mui/styles";
import { ThemeProvider } from "@emotion/react";
import { ApolloProvider } from "@apollo/client";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import client from "./modules/core/utils/connection";
import theme from "./theme";
import Ops from "./modules/core/pages/Ops";
import ThankYou from "./modules/core/pages/ThankYou";
import Survey from "./modules/core/pages/Survey";

function App() {
  return (
    <div className="App">
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ApolloProvider client={client}>
              <BrowserRouter>
              <Routes>
                <Route path="/" element={<Ops />} />
                <Route exact path="/ops" element={<Ops />} />
                <Route exact path="/ref" element={<Survey />} />
                <Route exact path="/ref/:referenceNo" element={<Survey />} />
                <Route exact path="/thankyou/:id" element={<ThankYou />} />
              </Routes>
              </BrowserRouter>
            </ApolloProvider>
          </ThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </div>
  );
}

export default App;
